export default __webpack_public_path__ + "img/error-illustration.e658cdf1.svg";